// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"150":"Attendance","217":"StaffList","267":"Setting","521":"Log","672":"Admin","735":"StaffDetail"}[chunkId] || chunkId) + "." + {"150":"14629dc8","217":"a33b6223","267":"db15a1ad","521":"86fe0502","523":"81ab1ea4","672":"b162a2bc","735":"bdf88155"}[chunkId] + ".js";
};